(function () {
  var SELECTOR = '.cantein-table-scroll, .cantein-aa__table-wrap';

  function shadow(side) {
    var el = document.createElement('div');
    el.className = 'cantein-scroll-shadow cantein-scroll-shadow--' + side;
    el.setAttribute('aria-hidden', 'true');
    return el;
  }

  function setup(el) {
    var wrap = document.createElement('div');
    wrap.className = 'cantein-scroll-edge';
    el.parentNode.insertBefore(wrap, el);
    wrap.appendChild(el);
    var start = shadow('start');
    var end = shadow('end');
    wrap.appendChild(start);
    wrap.appendChild(end);

    function toggle() {
      var max = el.scrollWidth - el.clientWidth;
      start.classList.toggle('is-visible', max > 4 && el.scrollLeft > 4);
      end.classList.toggle('is-visible', max > 4 && el.scrollLeft < max - 4);
    }

    function layout() {
      var cs = getComputedStyle(el);
      var top = parseFloat(cs.borderTopWidth) || 0;
      var left = parseFloat(cs.borderLeftWidth) || 0;
      var right = parseFloat(cs.borderRightWidth) || 0;
      var radius = Math.max(0, (parseFloat(cs.borderTopRightRadius) || 0) - right) + 'px';
      [start, end].forEach(function (s) {
        s.style.top = el.offsetTop + top + 'px';
        s.style.height = el.clientHeight + 'px';
      });
      var pinned = el.querySelector('tr > :first-child:not([colspan])');
      var pinnedWidth = pinned && getComputedStyle(pinned).position === 'sticky' ? pinned.offsetWidth : 0;
      start.style.left = el.offsetLeft + left + pinnedWidth + 'px';
      start.style.borderRadius = pinnedWidth ? '0' : radius + ' 0 0 ' + radius;
      end.style.right = wrap.clientWidth - el.offsetLeft - el.offsetWidth + right + 'px';
      end.style.borderRadius = '0 ' + radius + ' ' + radius + ' 0';
      toggle();
    }

    el.addEventListener('scroll', toggle, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(layout).observe(el);
    else window.addEventListener('resize', layout);
    layout();
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
